import { createContext, useContext } from 'react';

import { StepProps } from 'components/Stepper/types';

import { BankTransferCreationStep } from './bankTransferContext';

type BankTransferStepContextState = Pick<
  StepProps<BankTransferCreationStep>,
  'goNext'
> &
  Partial<Pick<StepProps<BankTransferCreationStep>, 'goBack'>>;

export const BankTransferStepContext = createContext<
  BankTransferStepContextState | undefined
>(undefined);

export const useBankTransferStepContext = () => {
  const context = useContext(BankTransferStepContext);
  if (!context) {
    throw new Error(
      '"useStepContext" can only be used inside of a StepContext.Provider',
    );
  }
  return context;
};
